class StickyHeader {
  static async init () {
    return new StickyHeader()
  }

  constructor () {
    const $nav = $('.sticky-nav')
    const documentWidth = $(document).width()
    const condition = !$nav.hasClass('style-side') ? documentWidth > 720 : documentWidth > 720 && documentWidth < 992
    const stickOnMobile = $nav.hasClass('stick-on-mobile')

    if (($nav[0] && condition) || stickOnMobile) {
      const navOffset = $nav.offset().top
      const updateStickyOffsets = () => {
        const navOuterHeight = $nav.outerHeight(true) || 0
        const stickyTop = $nav.hasClass('sticky') ? navOuterHeight : 0
        const stickyGalleryTop = $nav.hasClass('sticky') ? navOuterHeight + 16 : 0

        $('.page-wrapper').css('padding-top', stickyTop)
        $('.sticky-gallery').css('top', stickyGalleryTop)
        $('.sticky-block').css('top', stickyTop)
        $('.subcategory__header').css('top', stickyTop)
      }

      window.onscroll = () => {
        if ((window.pageYOffset - 5) >= navOffset) {
          $nav.addClass('sticky')
        } else {
          $nav.removeClass('sticky')
        }

        updateStickyOffsets()
      }

      window.addEventListener('resize', updateStickyOffsets)
      updateStickyOffsets()
    }
  }
}
export default StickyHeader
